import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { useCallback, useEffect, useState ,useRef} from "react";
import theme from "./theme";
import { keyframes } from "@mui/system";
import { styled } from "@mui/material/styles";
import { postStatus,postUndo,nextLot } from "../../Model/DeclaratorModel";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import results from "src/pages/resultAuction/Results";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// import {socket} from "./../../Model/socket"
const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const BlinkedBox = styled("div")({
  animation: `${blink} 1s linear infinite`,
});

const ButtonsFunction = ({socketDeclarator,LiveDataddd,Datastatus}) => {
  const classes = theme();
  const [loading, setLoading] = useState(false);
  const [lotStatus, setLotStatus] = useState(Datastatus);
  const [lotStatus1, setLotStatus1] = useState("");
  const [results1, setResults1] = useState([]);
  // const [AuctionID, setLotAuctionID] = useState("LiveDataddd.auction_details.auction_id");
  // const [setId, setSetID] = useState("LiveDataddd.auction_details.set_slug");
  const [lot_number, setlotNumber] = useState("");
  // const [count, setCount] = useState(0); declarator/lot/undo
  const [highestBid, setHighestBid] = useState(0);
  const [reserved, setReserved] = useState("");
  const [openPass, setOpenPass] = useState(false);
  
  const handleClick =  useCallback(async (message) => {
 
    // setLoading(true)
    setOpenPass(false)
    //  setLotStatus(reserved <  highestBid ?  message:"RESERVE NOT MET");
    const DataBidStatus = {
      auction_id: LiveDataddd.auction_details.auction_id,
      setId: LiveDataddd.auction_details.id,
      lot_number: LiveDataddd.lot.details[0].lot_number,
      status: message,
    };
    if(message=== "NEXTSLOT" ){

    }else if(message=== "fresh"){
      
    // }else if(message=== "PASS"){
      

    }else{
      setLotStatus(LiveDataddd.lot.details[0].lot_status);
    }
   
    try {
        if (message !== "") {
          let count =  LiveDataddd.lot.details[0].lot_number + 1;
          if (message === "NEXTSLOT"  ) {
            
             try {
                    async function nextLotData() {
                      const results = await nextLot(DataBidStatus);
                     console.log(results.msg)
                      // setLotStatus('PENDING');
                      // console.log("results",results)
                      // return ListData();
                      if (results.success === true) {
                      socketDeclarator.emit("send_status", {
                        status: true,
                        message: message,
                        nextCount: LiveDataddd.lot.details[0].lot_number,
                      });
                    }else{

                    }
                    }
                    nextLotData().catch(console.error);
                  } catch (error) {}
                 setLotStatus('PENDING');
                //  return ListData();
              }else if(message === "fresh" ){
                socketDeclarator.emit("send_status", {
                message: message,
          
           });
          } else {
            try {
              setLoading(true)
              const results = await postStatus(DataBidStatus);
              setLoading(false)
              // setLotStatus(message);
              //alert(results.msg)
              if (results.success === true) {
                setLotStatus(results.status);
                // setLotStatus1("")
                // alert(results.status)
                if (message === "SOLD" || message === "UNSOLD" ) {
                   socketDeclarator.emit("send_status", {
                    status: true,
                    message: results.status,
                    nextCount:  LiveDataddd.lot.details[0].lot_number,
                  });
                  
                } else {
                  // setLotStatus('PENDING');
                  // alert("sss",message)
                    socketDeclarator.emit("send_status", {
                    status: true,
                    message: message,
                    nextCount:  LiveDataddd.lot.details[0].lot_number,
                  });
                  
                }
                //return ListData();
              } else {
                // alert(results.msg);

                socketDeclarator.emit("send_status", {
                  status: true,
                  message: message,
                  nextCount:  LiveDataddd.lot.details[0].lot_number,
                });
              }
              // setStatusMessage(message);
            } catch (error) {
              // setStatusMessage(message);
              console.log("error");
            }
          }
        }

    //  }
    //  getAuctionOne().catch(console.error);
    } catch (error) {}
    


  },[socketDeclarator,LiveDataddd]);

//   const handleClickUndo = () => {
//     const dataArray = {
//       auction_id: LiveDataddd.auction_details.auction_id,
//       setId: LiveDataddd.auction_details.id,
//       lot_number:LiveDataddd.lot.details[0].lot_number,
//     }

//     try {
//        setLoading(true)
//       async function functionUndo() {
//         const results = await postUndo(dataArray);
//         setLoading(false)
//       //  console.log(":results declarator: ",results)
//       if(results.success === true){
//         socketDeclarator.emit("send_status", {
//           status: results.success,
//           message: 'undo'
//         });
//       }else{

//       }
//         console.log('functionUndo: ',results)

//       }
//       functionUndo().catch(console.error);
//     } catch (error) {}

//  }




const handleClickPass = () => {
  setOpenPass(true);
};

const handleClosePass = () => {
  setOpenPass(false);
}
  useEffect(() =>{

   
   
     try {
      socketDeclarator.on("receive_status", (data) => {
        // alert(data.message)
        setLotStatus(data.message === "NEXTSLOT" ? "PENDING":data.message)
      });
  
      // socketDeclarator.on("receive_bid_amount", (data) => {
      //   console.log("receive amount ",data)
 
        
      // });

      
        setReserved(LiveDataddd.lot.details[0].reserve_price);
        setHighestBid(LiveDataddd.bid_history[0].hammer);
      // console.log(LiveDataddd.lot.details[0].reserve_price)
      // console.log(LiveDataddd.bid_history[0].hammer)

        setLotStatus(LiveDataddd.lot.details[0].lot_status)
        setlotNumber(LiveDataddd.lot.details[0].lot_number)
        } catch (error) {
          

        setReserved(LiveDataddd.lot?.details[0].reserve_price);


       setlotNumber(LiveDataddd.lot?.details[0].lot_number)
          setLotStatus(LiveDataddd.lot?.details[0].lot_status)
   
        }



      return () => {
        socketDeclarator.off("receive_bid_amount");
        socketDeclarator.off("send_status");
        socketDeclarator.off("receive_status");
        
      };
          // alert(LiveDataddd.lot.details[0].lot_status)
  },[socketDeclarator,LiveDataddd,Datastatus])



  return (
    <div style={{ padding: 10 }}>
      <div style={{margin: "auto"}}>

    
      <Box style={{display: "flex",  alignItems: "center",justifyContent: "center"}}>
      <Typography align="center" variant="h5">
       STATUS :  
        </Typography>
      
        <Typography align="center" variant="h5" style={{whiteSpace:"break-spaces"}}>
        <BlinkedBox style={{  color: (lotStatus === "SOLD"&& Datastatus === "" )|| Datastatus === "SOLD" ?'green': "red",}}> {Datastatus ? Datastatus === "NEXTSLOT" ? "PENDING":Datastatus  === "PASS" ? "PENDING":Datastatus: lotStatus === "PASS" ? "PENDING":lotStatus }</BlinkedBox>
        </Typography>
      </Box>
      </div>
      <Grid item xs={12} spacing={4}>
        <Box
          display="flex"
          justifyContent="flex-end"
          style={{ marginTop: "20px" }}
        >
          {/* <Button
            fullWidth
            disabled={lotStatus === "OPEN" || lotStatus === "PAUSE" || lotStatus === "PENDING" ? true : false}
            style={{ margin: 2 }}
            variant="contained"
            color="inherit"
            onClick={() => handleClick("UNSOLD")}
            className={`${classes.buttonRed} ${classes.ButtonCustom}`}
          >
            UNSOLD
          </Button> */}

          <Button
            fullWidth
            disabled={(lotStatus === "OPEN"  && Datastatus === "") || Datastatus === "OPEN"  ||  (lotStatus === "PAUSE"  && Datastatus === "") || Datastatus === "PAUSE"  || (lotStatus === "PENDING"  && Datastatus === "") || Datastatus === "PENDING"  ? true : false}
            style={{ margin: 2,color: 'white' }}
            variant="contained"
            color="inherit"
            onClick={() => handleClick("SOLD")}
            className={ (lotStatus === "SOLD" && Datastatus === "") || Datastatus === "SOLD" ?`${classes.buttonSuccess} ${classes.ButtonCustom}`: (lotStatus === "UNSOLD" && Datastatus === "") || Datastatus === "UNSOLD" ? `${classes.buttonRed} ${classes.ButtonCustom}`:`${classes.buttonNormal} ${classes.ButtonCustom} `}
            // className={`${classes.buttonGreen} ${classes.ButtonCustom}`}
          >
            SOLD
          </Button>

          <Button
            fullWidth
            disabled={lotStatus === "SOLD" ||  lotStatus === "UNSOLD" || lotStatus === "RESERVE_NOT_MET"  ? true : false}
            style={{ margin: 3,color: 'white'  }}
            variant="contained"
            color="inherit"
            onClick={() => handleClick("FAIR_WARNING")}
            className={(lotStatus === "FAIR_WARNING"  && Datastatus === "") || Datastatus === "FAIR_WARNING" ?`${classes.buttonOrange} ${classes.ButtonCustom}`: `${classes.buttonNormal} ${classes.ButtonCustom} `}
          >
            FAIR_WARNING
          </Button>
        </Box>
      </Grid>

      <Grid item xs={12} spacing={4}>
        <Box
          display="flex"
          justifyContent="flex-end"
          style={{ marginTop: "20px" }}
        >
          <Button
            fullWidth
            style={{ margin: 3,color: 'white' }}
            variant="contained"
            color="inherit"
            onClick={() => handleClick("PAUSE")}
            className={lotStatus === "PAUSE" ?`${classes.pauseButton} ${classes.ButtonCustom}`:`${classes.buttonNormal} ${classes.ButtonCustom} `}
            // className={`${classes.pauseButton} ${classes.ButtonCustom}`}
          >
            PAUSE
          </Button>

          <Button
            style={{ margin: 3,color: 'white' }}
            fullWidth
            variant="contained"
            // color={lotStatus === "OPEN" && Datastatus === "" || Datastatus === "OPEN" ?"primary":"inherit"} 
            onClick={() => handleClick("OPEN")}
           
          className={(lotStatus === "OPEN" && Datastatus === "") || Datastatus === "OPEN" ?`${classes.buttonBlue} ${classes.ButtonCustom}`: `${classes.buttonNormal} ${classes.ButtonCustom} `}
          >
            OPEN
          </Button>
        </Box>
      </Grid>

      <Grid item xs={12} spacing={4}>
        <Box
          display="flex"
          justifyContent="flex-end"
          style={{ marginTop: "20px" }}
        >
          <Button
            fullWidth
            style={{ margin: 2,color: 'white' }}
            variant="contained"
            color="inherit"
            onClick={() => handleClickPass()}
            className={`${classes.buttonNormal} ${classes.ButtonCustom} `}
          >
            PASS
            {/* PASS
                  OPEN
                  PENDING
                  RESERVE_NOT_MET
                  UNSOLD */}
          </Button>
          <Button
            disabled={
             ( lotStatus === "UNSOLD"   && Datastatus === "") || Datastatus === "UNSOLD" ||( lotStatus === "SOLD"  && Datastatus === "") || Datastatus === "SOLD"||  (lotStatus === "RESERVE_NOT_MET"  && Datastatus === "") || Datastatus === "RESERVE_NOT_MET" ||  (lotStatus === "PASS"  && Datastatus === "") || Datastatus === "PASS"  ? false : true
            }
            fullWidth
            style={{ margin: 2,color: 'white' }}
            variant="contained"
            color="inherit"
            onClick={() => handleClick("NEXTSLOT")}
            className={(lotStatus === "SOLD" && Datastatus === "" )|| Datastatus === "SOLD"  || lotStatus  === "UNSOLD" || lotStatus  === "PASS" ?`${classes.buttonGreen} ${classes.ButtonCustom}`:`${classes.buttonNormal} ${classes.ButtonCustom} `}
            // className={`${classes.buttonGreen} ${classes.ButtonCustom}`}
          >
            NEXT SLOT
          </Button>
        </Box>
      </Grid>

      <Grid item xs={12} spacing={4}>
        <Box
          display="flex"
          justifyContent="flex-end"
          style={{ marginTop: "20px" }}
        >
          {/* <Button
            fullWidth
            style={{ margin: 2 }}
            variant="contained"
            color="inherit"
            onClick={() => handleClickUndo()}
            className={`${classes.buttonGray} ${classes.ButtonCustom}`}
          >
            UNDO
           
          </Button> */}
          <Button
            fullWidth
            style={{ margin: 2,color: 'white' }}handleClickUndo
            variant="contained"
            color="inherit"
            onClick={() => handleClick("fresh")}
            className={`${classes.buttonNormal} ${classes.ButtonCustom} `}
          >
            Refresh along with other connected users
          </Button>
        </Box>
      </Grid>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog
        open={openPass}
        onClose={handleClosePass}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
         <DialogTitle>Confirm Lot Status</DialogTitle>

        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
          <Typography style={{fontSize: 20}}>
          Are you sure you want to mark this lot as <strong>Passed</strong>?
        </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
    
        <Button onClick={handleClosePass} color="error" variant="outlined">
          Cancel
        </Button>
        <Button onClick={(e) => handleClick("PASS")} color="primary" variant="contained">
          Yes, Mark as Passed
        </Button>

       
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ButtonsFunction;
